import { Typography } from "ui/typography";

import type { JsonFormSectionHeadingLevel } from "containers/admin/clients/client/components/form-builder/form-schema";

export const renderSectionHeading = (label: string, headingLevel: JsonFormSectionHeadingLevel) => {
  if (headingLevel === "section") {
    return (
      <Typography
        component="h4"
        variant="subtitle1"
        sx={(theme) => ({ fontWeight: 700, color: theme.palette.secondary.main })}
      >
        {label}
      </Typography>
    );
  }

  if (headingLevel === "field-group") {
    return (
      <Typography component="h6" variant="subtitle2" sx={(theme) => ({ color: theme.palette.grey[900] })}>
        {label}
      </Typography>
    );
  }

  if (headingLevel === "heading-sm") {
    return (
      <Typography
        component="h5"
        variant="body1"
        sx={(theme) => ({ fontWeight: 600, color: theme.palette.grey[900] })}
      >
        {label}
      </Typography>
    );
  }

  return (
    <Typography component="h5" variant="subtitle1" sx={(theme) => ({ color: theme.palette.grey[900] })}>
      {label}
    </Typography>
  );
};
